import { getPlantDetails } from '../services/PlantServices';
import { getBgImageLogo } from '../services/LoginServices';
import { fetchImageDataUrl } from './pdfMedia';

function resolvePlantId(selectedPlant, plants) {
    if (selectedPlant?.length && !selectedPlant.some((item) => item.value === 'select-all')) {
        return selectedPlant[0].value;
    }
    return plants[0]?.value || null;
}

export async function buildCustomerLedgerPdfHeader(cookies, selectedPlant, plants, options = {}) {
    const plantId = resolvePlantId(selectedPlant, plants);
    let companyName = '';
    let addressLines = [];
    let gstNo = '';
    let logoPath = '';

    if (plantId) {
        try {
            const plant = await getPlantDetails(cookies, plantId);
            companyName = plant.entity_name || '';
            const line1 = [plant.address_1, plant.address_2].filter(Boolean).join(', ');
            const line2 = [plant.address_3, plant.state, plant.pincode].filter(Boolean).join(' - ');
            const contactParts = [];
            if (plant.phone_number || plant.mobile_number) {
                contactParts.push(`Cell: ${[plant.phone_number, plant.mobile_number].filter(Boolean).join(', ')}`);
            }
            if (plant.email_id) {
                contactParts.push(`Email: ${plant.email_id}`);
            }
            addressLines = [line1, line2, contactParts.join(', ')].filter(Boolean);
            gstNo = plant.gst_no || '';
            logoPath = plant.plant_logo || '';
        } catch (error) {
            // Fall back to company logo below.
        }
    }

    if (!companyName) {
        try {
            const response = await getBgImageLogo();
            const company = (response.company_list || []).find((item) => item.status)
                || response.company_list?.[0];
            if (company) {
                companyName = company.name || '';
                logoPath = logoPath || company.logo || '';
            }
        } catch (error) {
            // Header can render without logo.
        }
    }

    const logoDataUrl = logoPath
        ? await fetchImageDataUrl(cookies, logoPath).catch(() => null)
        : null;

    return {
        logoDataUrl,
        companyName,
        addressLines,
        gstNo,
        documentTitle: options.documentTitle || 'Customer Ledger',
        subtitle: options.subtitle || '',
    };
}
